import script from "./SplitHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SplitHeader.vue?vue&type=style&index=0&id=7b2f2bbf&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b2f2bbf"]])

export default __exports__